import { createAxiosClient } from '~/shared/api'

export default defineNuxtPlugin(nuxtApp => {
  const instance = createAxiosClient({
    baseURL: useRuntimeConfig().innerBackUrl || 'http://localhost:3000',
    browserBaseUrl: '',
  })

  nuxtApp.provide('axios', instance)
})
